import { getApiActionCreator } from 'helpers/actionHelper';
import * as actionTypes from './constants';

export const getPhysicalConnectionsAction = getApiActionCreator(actionTypes.GET_PHYSICAL_CONNECTIONS);

export const getPhysicalConnections = (assetId) => ({
    type: actionTypes.GET_PHYSICAL_CONNECTIONS_REQUEST,
    assetId
});

export const clearPhysicalConnections = () => ({
    type: actionTypes.CLEAR_PHYSICAL_CONNECTIONS
});
